const updateBackLinkTitle = ( backLink ) => {
	const parentItem = backLink.parentElement?.parentElement;
	const parentLink = parentItem?.querySelector( ':scope > a.mega-menu-link' );
	const heading =
		parentLink &&
		Array.from( parentLink.children ).find(
			( child ) => child.tagName === 'H3'
		);

	if ( ! heading ) {
		return;
	}

	const title =
		backLink.querySelector(
			'.mega-description-group > .mega-menu-title'
		) || backLink.querySelector( '.mega-mobile-back-link-text' );

	if ( title ) {
		title.textContent = heading.textContent.trim();
	}

	if ( backLink.querySelector( 'a.mega-mobile-back-link-text' ) ) {
		backLink
			.querySelector( 'button.mega-mobile-back-link' )
			?.setAttribute( 'aria-label', heading.textContent.trim() );
	}
};

const updateAddedBackLinks = ( node ) => {
	if ( node.nodeType !== 1 ) {
		return;
	}

	if ( node.matches( 'li.mega-mobile-back' ) ) {
		updateBackLinkTitle( node );
	}

	node.querySelectorAll( 'li.mega-mobile-back' ).forEach(
		updateBackLinkTitle
	);
};

export default {
	init() {
		document
			.querySelectorAll( 'li.mega-mobile-back' )
			.forEach( updateBackLinkTitle );

		const observer = new window.MutationObserver( ( records ) => {
			records.forEach( ( record ) => {
				record.addedNodes.forEach( updateAddedBackLinks );
			} );
		} );

		observer.observe( document.body, { childList: true, subtree: true } );
	},
};
